import axios from 'axios'
import { Message, MessageBox, Loading } from 'element-ui'
import { app } from '../main'
import { del, get } from './localStorage';
// import store from '../store'
// import { getToken } from '@/utils/auth'

// 创建axios实例
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const service = axios.create({
    // baseURL: process.env.VUE_APP_API_URL,
    baseURL: process.env.NODE_ENV == 'production' ? VUE_APP_API_URL : 'https://tadmin.e-dwo.com/api/1/1',
    timeout: 12000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        // 让每个请求携带自定义token 请根据实际情况自行修改
        // if (store.getters.token) {
        //     config.headers['X-Token'] = getToken()
        // }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        /**
         * code为非20000是抛错 可结合自己业务进行修改
         */
        console.log('api ok');
        const res = response.data;

        if (res.status !== "ok" && res.status !== "OK" && res.status !== "關注成功" && res.status !== "发送成功") {
            const error_msg = app.$t('error_code')[res.status] ? app.$t('error_code')[res.status] : 'error code: ' + res.status;

            Message({
                message: error_msg,
                type: 'error',
                duration: 5 * 1000
            })

            // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                MessageBox.confirm(
                    app.$t('alert_message.logout_title'),
                    app.$t('alert_message.logout_msg'), {
                        confirmButtonText: app.$t('btns.resignin'),
                        cancelButtonText: app.$t('btns.cancel'),
                        type: 'warning'
                    }
                ).then(() => {
                    store.dispatch('FedLogOut').then(() => {
                        location.reload() // 为了重新实例化vue-router对象 避免bug
                    })
                })
            }
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        console.log('api error');
        console.log(error.response) // for debug
        const res = error.response.data;
        // 如果是取得關注清單發生錯誤
        if (error.response.config.url.includes('memberLike')) {
            // 判斷是否是關注列表，如果不是的話就不報錯
            const token = get('token');
            // 如果有token代表有登入，繼續往下，如果沒token就代表沒登入
            if (!token) {
                // 這邊判斷不是關注列表而，就不要強制跳登入
                if (!app.$route.name != 'favorite') {
                    return Promise.resolve();
                }
            }
            return Promise.resolve();
        }
        console.log(app.$t('error_code')[res.status]);
        const error_msg = app.$t('error_code')[res.status] ? app.$t('error_code')[res.status] : 'error code: ' + res.status;
        Message({
            // message: error.message,
            message: error_msg, // 20200819 訊息放在status里？
            type: 'error',
            duration: 5 * 1000
        })

        // token过期？
        if (error.response.status == 401) {
            // 清除本地资料并跳到登入页面
            del('token');
            del('userInfo');
            app.$store.commit('CLEAN_USER_INFO');
            app.$router.push({ name: 'register', query: { type: 'login' } });
            let loadingInstance = Loading.service();
            loadingInstance.close();
        }
        return Promise.reject(error)
    }
)

export default service